var OAuthListInternalEvents;
(function(OAuthListInternalEvents) {
    OAuthListInternalEvents["LOGIN_SUCCESS"] = 'oauthlist: success login';
})(OAuthListInternalEvents || (OAuthListInternalEvents = {}));

export { OAuthListInternalEvents };
